
import { updateAppConfig } from '#app'
import { defuFn } from '/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/node_modules/defu/dist/defu.mjs'

const inlineConfig = {
  "nuxt": {
    "buildId": "ac6c602f-14a8-4bce-acce-4f6902c3f62b"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /* #__PURE__ */ defuFn(inlineConfig)
